'use es6';

import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as FormActions from 'MeetingsLib/redux/actions/FormActions';
import UICardWrapper from 'UIComponents/card/UICardWrapper';
import UICardSection from 'UIComponents/card/UICardSection';
import SkeletonDurationPicker from 'MeetingsLib/components/schedule/duration/SkeletonDurationPicker';
import DurationPicker from 'MeetingsLib/components/schedule/duration/DurationPicker';
import SkeletonTimePicker from 'MeetingsLib/components/schedule/time/SkeletonTimePicker';
import TimePicker from 'MeetingsLib/components/schedule/time/TimePicker';
import TimePickerV2 from '../schedule/time/TimePickerV2';
import StepButtonsFooter from 'MeetingsLib/components/page/StepButtonsFooter';
import UserProfile from 'MeetingsBase/models/UserProfile';
import Branding from 'MeetingsBase/models/Branding';
import { getIsUngatedForAvailabilityDaysLimit } from 'MeetingsLib/selectors/BookInfoSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
class TimeOptionsSection extends Component {
  constructor(...args) {
    super(...args);
    this.handleGoToPreviousStep = () => {
      const {
        resetEventDateTime,
        goToPreviousStep
      } = this.props;
      resetEventDateTime();
      goToPreviousStep();
    };
    this.renderTimePicker = () => {
      const {
        branding,
        compact,
        isFetchingPublicAvailability,
        isUngatedForAvailabilityDaysLimit,
        profile,
        TimePickerMarker
      } = this.props;
      if (isFetchingPublicAvailability) {
        return /*#__PURE__*/_jsx(SkeletonTimePicker, {});
      }
      const TimePickerComponent = isUngatedForAvailabilityDaysLimit ? TimePickerV2 : TimePicker;
      return /*#__PURE__*/_jsx(TimePickerComponent, {
        branding: branding,
        compact: compact,
        profile: profile,
        TimePickerMarker: TimePickerMarker
      });
    };
    this.renderDurationPicker = () => {
      if (this.props.isFetchingPublicAvailability) {
        return /*#__PURE__*/_jsx(SkeletonDurationPicker, {});
      }
      return /*#__PURE__*/_jsx(DurationPicker, {});
    };
    this.renderStepButtonsFooter = () => {
      const {
        branding,
        compact
      } = this.props;
      if (!compact) {
        return null;
      }
      return /*#__PURE__*/_jsx(StepButtonsFooter, {
        branding: branding,
        compact: compact,
        goToPreviousStep: compact ? this.handleGoToPreviousStep : null
      });
    };
  }
  render() {
    const {
      compact
    } = this.props;
    return /*#__PURE__*/_jsxs(UICardWrapper, {
      className: "m-bottom-0 flex-column min-height-0 height-100",
      children: [/*#__PURE__*/_jsxs(UICardSection, {
        flush: true,
        className: "p-all-0 m-bottom-0 flex-column min-height-0 height-100",
        scrollable: compact,
        children: [this.renderDurationPicker(), this.renderTimePicker()]
      }), this.renderStepButtonsFooter()]
    });
  }
}
TimeOptionsSection.propTypes = {
  branding: PropTypes.instanceOf(Branding).isRequired,
  compact: PropTypes.bool.isRequired,
  isFetchingPublicAvailability: PropTypes.bool.isRequired,
  goToPreviousStep: PropTypes.func,
  profile: PropTypes.instanceOf(UserProfile).isRequired,
  resetEventDateTime: PropTypes.func.isRequired,
  TimePickerMarker: PropTypes.func.isRequired,
  isUngatedForAvailabilityDaysLimit: PropTypes.bool
};
export default connect(state => ({
  isUngatedForAvailabilityDaysLimit: getIsUngatedForAvailabilityDaysLimit(state)
}), FormActions)(TimeOptionsSection);